import React, { FC, MouseEvent, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Icon } from "../../common";
import { useTriggerToastOnRTKError } from "../../../hooks/useTriggerToastOnRTKError";
import { ROUTES } from "../../../routes";
import { useDuplicateInvoiceMutation } from "../../../store/services/invoices";
import { Tooltip } from "../../common/Tooltip";

type Props = {
  className?: string;
  invoiceId: string;
  label?: boolean;
  tooltip?: boolean;
};

export const DuplicateInvoiceAction: FC<Props> = ({
  className,
  invoiceId,
  label = false,
  tooltip = false,
}) => {
  const navigate = useNavigate();

  const [
    duplicateInvoice,
    { data: newInvoice, isSuccess, isLoading, isError, error },
  ] = useDuplicateInvoiceMutation();

  useTriggerToastOnRTKError(isError, error);

  const duplicateHandler = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    await duplicateInvoice(invoiceId);
  };

  useEffect(() => {
    if (isSuccess) {
      newInvoice && navigate(ROUTES.INVOICE.replace(":id", newInvoice.id));
    }
  }, [isLoading, isSuccess, navigate, newInvoice]);

  const variant = label ? Button.variant.TERTIARY : Button.variant.SECONDARY;

  const button = (
    <Button
      contentClassName={className}
      icon={!label}
      onClick={duplicateHandler}
      variant={variant}
    >
      {label && <>Duplicate</>}
      <Icon icon="Copy" size={24} className="text-gray-500" disableFill />
    </Button>
  );

  if (tooltip) {
    return (
      <Tooltip text="Duplicate invoice" position="bottom">
        {button}
      </Tooltip>
    );
  }

  return button;
};
